import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Select from "react-select";

import {
  faEye,
  faPenToSquare,
  faTrash,
  faEnvelope,
  faHistory,
  faCopy,
  faInfoCircle,
  fasLocationDot,
  faLocationDot,
  faUserCheck,
  faUserXmark,
  faUsers,
  faCalendarDays,
  faMoneyBillWave,
} from "@fortawesome/free-solid-svg-icons";
import Add_data_modal from "../../components/users/update_data_modal";
import Layouts from "../../layouts/layouts";
import UserDetailModal from "../../components/users/User Details";
import * as XLSX from "xlsx";
import moment from "moment";
import DataTable_Component from "../../components/users/Data Table/index";
import Status_modal from "../../components/manageInvoice/status_modal/index";
import Switch from "react-switch";
import { Tooltip } from "react-tooltip";

export default function User() {
  const [clientCounts, setClientCounts] = useState({}); // State for client counts

  const navigate = useNavigate();

  const title = "Users Details";
  const [apistate, setApiState] = useState([]);
  const [apicol, setApiCol] = useState([]);
  const [selectVal, setSelectval] = useState([]);
  const [openModal, setOpenModal] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [open_update_modal, setOpen_update_modal] = useState({
    render: true,
    modal_open: false,
  });
  const [update_modal_data, setUpdate_modal_data] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [showUserDetailModal, setShowUserDetailModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [presentCount, setPresentCount] = useState(0);
  const [absentCount, setAbsentCount] = useState(0);
  const [totalUsers, setTotalUsers] = useState(0);
  const [originalUsers, setOriginalUsers] = useState([]); // full dataset
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [displayedUsers, setDisplayedUsers] = useState([]);
  const [selectedVehicle, setSelectedVehicle] = useState("");
  const [selectedClient, setSelectedClient] = useState("");
  const [selectedDutyType, setSelectedDutyType] = useState("");
  const [leaveCount, setLeaveCount] = useState(0);
  const [totalBasicSalary, setTotalBasicSalary] = useState(0);
  const [vehicles, setVehicles] = useState([]); // Store fetched vehicles
  const [clients, setClients] = useState([]); // Store fetched clients
  const applyLeaveButtonRef = useRef(null);
  const [showLeaveModal, setShowLeaveModal] = useState(false);
  const [leaveTypes, setLeaveTypes] = useState([]);
  const [selectedLeaveType, setSelectedLeaveType] = useState("");
  const [leaveStartDate, setLeaveStartDate] = useState("");
  const [leaveEndDate, setLeaveEndDate] = useState("");
  const [selectedLeaveUser, setSelectedLeaveUser] = useState(null);
  const [todayLeaveMap, setTodayLeaveMap] = useState({});
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [totalRows, setTotalRows] = useState(0);
  const [dataFilter, setDataFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [clientFilter, setClientFilter] = useState("");
  const [staffTypeFilter, setStaffTypeFilter] = useState("");
  const [monthFilter, setMonthFilter] = useState("");
  const [fullUsers, setFullUsers] = useState([]);
  const [attendanceFilter, setAttendanceFilter] = useState("");
  const [rentalFilter, setRentalFilter] = useState("");
  const [userSourceFilter, setUserSourceFilter] = useState("");
  const [thirdPartyProviderFilter, setThirdPartyProviderFilter] = useState("");
  const [simTrackingLoading, setSimTrackingLoading] = useState(null);
  const [reconsentLoading, setReconsentLoading] = useState(null);
  const [manualAttendanceDate, setManualAttendanceDate] = useState(
    moment().format("YYYY-MM-DD"),
  );
  const [formData, setFormData] = useState({
    id_vehicle: "", // For storing selected vehicle ID
  });
  const [errors, setErrors] = useState({}); // Validation errors
  const [stateUpdated, setStateUpdated] = useState(false);
  const [buttonPosition, setButtonPosition] = useState({});
  const manualCheckInButtonRef = useRef(null);
  const userRole = localStorage.getItem("userRole");
  const calculateTotalBasicSalary = (usersList) => {
    const total = usersList.reduce((acc, user) => {
      if (user.status !== "Active") return acc;

      if (!Array.isArray(user.salary)) return acc;

      const userTotal = user.salary.reduce(
        (sum, s) => sum + (Number(s.basic_pay) || 0),
        0,
      );

      return acc + userTotal;
    }, 0);

    setTotalBasicSalary(total);
  };

  const formatTime = (datetimeString) => {
    if (!datetimeString) return "";

    const date = new Date(datetimeString);
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    return `${hours}:${minutes}:${seconds}`;
  };

  const isToday = (dateString) => {
    if (!dateString) return false;

    const today = new Date();
    const dateToCheck = new Date(dateString);

    return (
      today.getDate() === dateToCheck.getDate() &&
      today.getMonth() === dateToCheck.getMonth() &&
      today.getFullYear() === dateToCheck.getFullYear()
    );
  };

  const getUserClientCounts = (users) => {
    return users.reduce((acc, user) => {
      const client = user.id_client ? user.id_client.name : "N/A";
      acc[client] = (acc[client] || 0) + 1;
      return acc;
    }, {});
  };
  const userClientCounts = getUserClientCounts(apistate);

  const handleSimTrackingToggle = async (row, checked) => {
    try {
      const token = localStorage.getItem("token");

      if (!token) {
        Swal.fire("Error!", "Authentication token not found.", "error");
        return;
      }

      if (!row?._id) {
        Swal.fire("Error!", "User ID not found.", "error");
        return;
      }

      setSimTrackingLoading(row._id);

      // ==========================================
      // TURN ON -> INVITE USER
      // ==========================================
      if (checked) {
        const response = await axios.post(
          `${process.env.REACT_APP_BASE_URL}/api/v1/user/${row._id}/sim-tracking/invite`,
          {},
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        if (response.status === 200 && response.data?.success) {
          const updatedUser = response.data.user;

          setApiState((prevState) =>
            prevState.map((item) =>
              item._id === row._id
                ? {
                    ...item,
                    simTrackingEnabled: updatedUser?.simTrackingEnabled ?? true,
                    telenityEntityId:
                      updatedUser?.telenityEntityId ?? item.telenityEntityId,
                  }
                : item,
            ),
          );

          Swal.fire(
            "Success!",
            `${row.name} invited for SIM based tracking successfully.`,
            "success",
          );
        } else {
          Swal.fire(
            "Error!",
            response.data?.message || "Failed to invite user.",
            "error",
          );
        }
      }

      // ==========================================
      // TURN OFF -> REMOVE USER
      // ==========================================
      else {
        const response = await axios.delete(
          `${process.env.REACT_APP_BASE_URL}/api/v1/user/${row._id}/sim-tracking`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        if (response.status === 200 && response.data?.success) {
          setApiState((prevState) =>
            prevState.map((item) =>
              item._id === row._id
                ? {
                    ...item,
                    simTrackingEnabled: false,
                    telenityEntityId: null,
                  }
                : item,
            ),
          );

          Swal.fire(
            "Success!",
            `${row.name} removed from SIM based tracking successfully.`,
            "success",
          );
        } else {
          Swal.fire(
            "Error!",
            response.data?.message || "Failed to remove user.",
            "error",
          );
        }
      }
    } catch (error) {
      console.error("SIM Tracking Toggle Error:", error);

      Swal.fire(
        "Error!",
        error.response?.data?.message ||
          "Failed to update SIM tracking status.",
        "error",
      );
    } finally {
      setSimTrackingLoading(null);
    }
  };

  // ==========================================
  // RECONSENT - REINITIATE JIO CONSENT
  // ==========================================

  const handleReconsentToggle = async (row) => {
    try {
      const token = localStorage.getItem("token");

      if (!token) {
        Swal.fire("Error!", "Authentication token not found.", "error");
        return;
      }

      if (!row?._id) {
        Swal.fire("Error!", "User ID not found.", "error");
        return;
      }

      // Reconsent is allowed only when SIM Tracking is ON
      if (!row.simTrackingEnabled) {
        Swal.fire(
          "SIM Tracking Required",
          "Please enable SIM Tracking before reinitiating consent.",
          "warning",
        );
        return;
      }

      setReconsentLoading(row._id);

      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/v1/user/${row._id}/sim-tracking/reconsent`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response.status === 200 && response.data?.success) {
        Swal.fire(
          "Success!",
          `${row.name}'s consent has been reinitiated successfully.`,
          "success",
        );
      } else {
        Swal.fire(
          "Error!",
          response.data?.message || "Failed to reinitiate consent.",
          "error",
        );
      }
    } catch (error) {
      console.error("Reconsent Toggle Error:", error);

      Swal.fire(
        "Error!",
        error.response?.data?.message || "Failed to reinitiate consent.",
        "error",
      );
    } finally {
      setReconsentLoading(null);
    }
  };

  const handleSimTrackingStatusToggle = async (row, checked) => {
    try {
      const token = localStorage.getItem("token");
      console.log("SIM TRACKING TOKEN:", token);
      console.log("SIM TRACKING USER ID:", row?._id);
      console.log(
        "SIM TRACKING URL:",
        `${process.env.REACT_APP_BASE_URL}/api/v1/user/${row._id}/sim-tracking/enable`,
      );

      if (!token) {
        Swal.fire("Error!", "Authentication token not found.", "error");
        return;
      }

      if (!row?._id) {
        Swal.fire("Error!", "User ID not found.", "error");
        return;
      }

      setSimTrackingLoading(row._id);

      // ================================
      // ENABLE TELENITY TRACKING
      // ================================
      if (checked) {
        const response = await axios.put(
          `${process.env.REACT_APP_BASE_URL}/api/v1/user/${row._id}/sim-tracking/enable`,
          {},
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        if (response.status === 200 && response.data?.success) {
          setApiState((prevState) =>
            prevState.map((item) =>
              item._id === row._id
                ? {
                    ...item,
                    simTrackingTracked: true,
                  }
                : item,
            ),
          );

          Swal.fire(
            "Success!",
            `${row.name} SIM tracking enabled successfully.`,
            "success",
          );
        }
      }

      // ================================
      // DISABLE TELENITY TRACKING
      // ================================
      else {
        const response = await axios.put(
          `${process.env.REACT_APP_BASE_URL}/api/v1/user/${row._id}/sim-tracking/disable`,
          {},
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        if (response.status === 200 && response.data?.success) {
          setApiState((prevState) =>
            prevState.map((item) =>
              item._id === row._id
                ? {
                    ...item,
                    simTrackingTracked: false,
                  }
                : item,
            ),
          );

          Swal.fire(
            "Success!",
            `${row.name} SIM tracking disabled successfully.`,
            "success",
          );
        }
      }
    } catch (error) {
      console.error("SIM Tracking Status Error:", error);

      Swal.fire(
        "Error!",
        error.response?.data?.message ||
          "Failed to update SIM tracking status.",
        "error",
      );
    } finally {
      setSimTrackingLoading(null);
    }
  };

  // Columns definition

  const columns = [
    {
      name: <b>Tracking</b>,
      cell: (row) => (
        <>
          <button
            onClick={() => handleUserTrackingClick(row)}
            className="btn btn-warning btn-sm ms-1"
          >
            <FontAwesomeIcon icon={faHistory} />
          </button>
        </>
      ),
      width: "100px",
    },

    {
      name: <b>Status</b>,
      cell: (row) => (
        <button
          className={`btn p-0 px-1 ${
            row.status.toLowerCase() === "active" && "btn-success"
          } ${row.status.toLowerCase() === "inactive" && "btn-danger"}
    `}
        >
          {row.status}
        </button>
      ),
    },

    ...(userRole === "superadmin"
      ? [
          {
            name: <b>Employee ID</b>,
            selector: (row) =>
              row.salary && row.salary.length > 0
                ? row.salary[0].id_employee
                : "-",
            sortable: true,
          },
          {
            name: <b>Basic Salary</b>,
            selector: (row) => {
              if (Array.isArray(row.salary) && row.salary.length > 0) {
                const totalBasic = row.salary.reduce(
                  (sum, sal) => sum + (sal.basic_pay || 0),
                  0,
                );
                return `${totalBasic}`;
              }
              return "-";
            },
            sortable: true,
          },
        ]
      : []),

    {
      name: <b>Name</b>,
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: "User Source",
      selector: (row) => row.userSource || "InHouse",
      sortable: true,
    },
    {
      name: "Third-Party Provider",
      selector: (row) => row.thirdPartyProvider || "-",
      sortable: true,
    },
    {
      name: <b>Joining Date</b>,
      selector: (row) => formatDate(row.joiningdate || "-"),
      sortable: true,
    },
    {
      name: <b>Clients</b>,
      selector: (row) => {
        if (Array.isArray(row.id_client)) {
          return row.id_client.map((client) => client.name).join(", ");
        } else {
          return "N/A";
        }
      },
      sortable: true,
    },
    {
      name: <b>Staff Type</b>,
      selector: (row) =>
        row.id_generalStaffType ? row.id_generalStaffType.name : "N/A",
      sortable: true,
    },
    // {
    //   name: <b>Duty Types</b>,
    //   selector: (row) =>
    //     Array.isArray(row.dutyTypes) && row.dutyTypes.length > 0
    //       ? row.dutyTypes.join(", ")
    //       : "Not Assigned",
    //   sortable: true,
    // },
    {
      name: <b>Check In</b>,
      selector: (row) =>
        isToday(row.attendance?.check_in)
          ? formatTime(row.attendance?.check_in)
          : "-",
      sortable: true,
    },
    {
      name: <b>Check Out</b>,
      selector: (row) =>
        isToday(row.attendance?.check_out)
          ? formatTime(row.attendance?.check_out)
          : "-",
      sortable: true,
    },
    ...(userRole === "superadmin"
      ? [
          {
            name: <b>Send Invite</b>,
            selector: (row) => (row.simTrackingEnabled ? "ON" : "OFF"),
            cell: (row) => (
              <Switch
                checked={!!row.simTrackingEnabled}
                onChange={(checked) => handleSimTrackingToggle(row, checked)}
                disabled={simTrackingLoading === row._id}
                onColor="#198754"
                offColor="#dc3545"
                onHandleColor="#ffffff"
                offHandleColor="#ffffff"
                height={22}
                width={44}
                handleDiameter={18}
                uncheckedIcon={false}
                checkedIcon={false}
              />
            ),
            width: "130px",
            center: true,
            sortable: true,
          },
          {
            name: <b>Reconsent</b>,

            selector: (row) => (row.simTrackingEnabled ? "CLICK" : "DISABLED"),

            cell: (row) => (
              <button
                type="button"
                className={`btn btn-sm ${
                  row.simTrackingEnabled ? "btn-success" : "btn-secondary"
                }`}
                onClick={() => handleReconsentToggle(row)}
                disabled={
                  !row.simTrackingEnabled ||
                  reconsentLoading === row._id ||
                  simTrackingLoading === row._id
                }
                style={{
                  minWidth: "75px",
                  fontWeight: "500",
                }}
              >
                {reconsentLoading === row._id ? "Loading..." : "Click"}
              </button>
            ),

            width: "130px",
            center: true,
            sortable: false,
          },

          {
            name: <b>SIM Live Tracking</b>,

            selector: (row) => (row.simTrackingTracked ? "ON" : "OFF"),

            cell: (row) => (
              <Switch
                checked={!!row.simTrackingTracked}
                onChange={(checked) =>
                  handleSimTrackingStatusToggle(row, checked)
                }
                disabled={
                  !row.simTrackingEnabled || simTrackingLoading === row._id
                }
                onColor="#198754"
                offColor="#dc3545"
                onHandleColor="#ffffff"
                offHandleColor="#ffffff"
                height={22}
                width={44}
                handleDiameter={18}
                uncheckedIcon={false}
                checkedIcon={false}
              />
            ),

            width: "150px",
            center: true,
            sortable: true,
          },
        ]
      : []),
    {
      name: <b>App Installed</b>,
      selector: (row) => (row.isLoggedIn ? "YES" : "NO"),
      cell: (row) => (
        <span
          className={`px-3 py-1 rounded-pill fw-bold text-white ${
            row.isLoggedIn ? "bg-success" : "bg-danger"
          }`}
          style={{ fontSize: "0.85rem" }}
        >
          {row.isLoggedIn ? "YES" : "NO"}
        </span>
      ),
      sortable: true,
      center: true,
      width: "130px",
    },
    {
      name: <b>Leave</b>,
      cell: (row) => {
        const today = new Date();
        const todayStr = today.toISOString().split("T")[0]; // Format: YYYY-MM-DD

        const startDate = row.leaveId?.startDate
          ? new Date(row.leaveId.startDate)
          : null;
        const endDate = row.leaveId?.endDate
          ? new Date(row.leaveId.endDate)
          : null;

        const isStartToday =
          startDate && startDate.toISOString().split("T")[0] === todayStr;

        const isEndToday =
          endDate && endDate.toISOString().split("T")[0] === todayStr;

        const isOnLeave = isStartToday || isEndToday;

        return (
          <span
            className={`px-3 py-1 rounded-pill fw-bold text-white ${
              isOnLeave ? "bg-success" : "bg-secondary"
            }`}
            style={{ fontSize: "0.85rem" }}
          >
            {isOnLeave ? "YES" : "NO"}
          </span>
        );
      },
      width: "120px",
    },

    ...(userRole === "superadmin"
      ? [
          {
            name: <b>Apply Leave</b>,
            selector: (row) => (todayLeaveMap[row._id] ? "True" : "False"),
            cell: (row) => {
              const isOnLeaveToday = todayLeaveMap[row._id];

              return (
                <Switch
                  checked={!!isOnLeaveToday}
                  disabled={!!isOnLeaveToday}
                  onChange={() => handleApplyLeave(row)}
                />
              );
            },
            sortable: false,
          },

          {
            name: <b>Manual Check-In</b>,
            selector: (row) => (row.manualCheckIn ? "True" : "False"),
            cell: (row) => {
              const hasCheckedOut = Boolean(row.attendance?.check_out);

              return (
                <Switch
                  checked={Boolean(row.manualCheckIn && !hasCheckedOut)}
                  onChange={() => handleManualCheckIn(row)}
                  disabled={false}
                />
              );
            },
            sortable: false,
          },

          {
            name: <b>Manual Check-Out</b>,
            cell: (row) => {
              const hasCheckedOut = Boolean(row.attendance?.check_out);
              const isCheckedIn = Boolean(row.manualCheckIn && !hasCheckedOut);

              return (
                <Switch
                  checked={false}
                  onChange={() => handleManualCheckOut(row)}
                  disabled={!isCheckedIn}
                />
              );
            },
            sortable: false,
          },
          {
            name: <b>GeoFencing</b>,
            selector: (row) => (row.geoFencing ? "True" : "False"),
            cell: (row) => (
              <Switch
                onChange={() => handleToggleGeoFencing(row)}
                checked={row.geoFencing}
              />
            ),
            sortable: true,
          },

          {
            name: <b>Multiple Check-In</b>,
            selector: (row) => (row.multipleCheckIn ? "True" : "False"),
            cell: (row) => (
              <Switch
                onChange={() => handleToggleMultipleCheckIn(row)}
                checked={row.multipleCheckIn}
              />
            ),
            sortable: true,
          },

          {
            name: <b>Tracking</b>,
            selector: (row) => (row.tracking ? "True" : "False"),
            cell: (row) => (
              <Switch
                onChange={() => handleToggleTracking(row)}
                checked={row.tracking}
              />
            ),
            sortable: true,
          },
        ]
      : []),
    {
      name: <b> On Rental</b>,
      selector: (row) => (row.rental ? "True" : "False"),
      cell: (row) => (
        <Switch onChange={() => handleToggleRental(row)} checked={row.rental} />
      ),
      sortable: true,
    },

    {
      name: <b>Action</b>,
      cell: (row) => (
        <>
          {/* Show Copy & Email buttons only if status is "created" */}
          {row.status === "created" && userRole === "superadmin" && (
            <>
              <button
                onClick={() => copyLink()}
                className="btn btn-success btn-sm"
              >
                <FontAwesomeIcon icon={faCopy} />
              </button>
              <button className="btn btn-primary btn-sm ms-1">
                <FontAwesomeIcon icon={faEnvelope} />
              </button>
            </>
          )}

          {/* Update button (Only for Superadmin) */}
          {userRole === "superadmin" && (
            <button
              onClick={() => setUpdateStoreBtn(row)}
              className="btn btn-info btn-sm ms-1"
            >
              <FontAwesomeIcon icon={faPenToSquare} />
            </button>
          )}

          {/* View button (Accessible to all roles) */}
          <button
            onClick={() => viewUser(row)}
            className="btn btn-primary btn-sm ms-1"
          >
            <FontAwesomeIcon icon={faEye} />
          </button>
          <button
            onClick={() => handleUserLiveHistoryClick(row)}
            className="btn btn-warning btn-sm ms-1"
          >
            <FontAwesomeIcon icon={faLocationDot} />
          </button>

          {/* User History button (Accessible to all roles) */}
          <button
            onClick={() => handleUserHistoryClick(row)}
            className="btn btn-warning btn-sm ms-1"
          >
            <FontAwesomeIcon icon={faHistory} />
          </button>
        </>
      ),
    },
  ];

  const handleUserLiveHistoryClick = (row) => {
    navigate(`/userlivetracking/${row._id}`);
  };
  const handleUserTrackingClick = (row) => {
    if (!row._id) {
      console.error("Error: userId is missing");
      return;
    }
    navigate(`/usertracking/${row._id}`);
  };

  useEffect(() => {
    const fetchVehicles = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          console.error("No token found");
          return;
        }

        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v1/vehicles`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        if (response.status === 200 && response.data.vehicles) {
          setVehicles(response.data.vehicles); // Update vehicles state
        } else {
          console.error("No vehicles found in the response.");
          setVehicles([]);
        }
      } catch (error) {
        console.error("Error fetching vehicles:", error);
        setVehicles([]); // Handle errors
      }
    };

    fetchVehicles();
  }, []);

  useEffect(() => {
    const fetchClients = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          console.error("No token found");
          return;
        }

        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v1/clients`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        if (response.status === 200 && response.data.clients) {
          setClients(response.data.clients); // Update vehicles state
        } else {
          console.error("No Client found in the response.");
          setClients([]);
        }
      } catch (error) {
        console.error("Error fetching clients:", error);
        setClients([]); // Handle errors
      }
    };

    fetchClients();
  }, []);

  const handleVehicleChange = (selectedOption) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      id_vehicle: selectedOption ? selectedOption.value : "",
    }));
  };

  const handleManualCheckIn = (row) => {
    setSelectedUser(row);
    setSelectedVehicle("");
    setSelectedClient("");
    setSelectedDutyType("");
    setManualAttendanceDate(moment().format("YYYY-MM-DD"));
    setShowModal(true);
  };

  const handleManualCheckOut = async (row) => {
    try {
      const userId = row._id;

      const numberplate =
        row.currentVehicle?.numberplate || row.vehicle?.numberplate;

      // Vehicle number plate is optional for non-drivers.
      const data = {
        id_user: userId,
        ...(numberplate && { numberplate }),
      };

      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/v1/user/manual-checkout`,
        data,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );

      if (response.status === 200 || response.data?.success) {
        Swal.fire(
          "Success!",
          "Manual Check-Out completed successfully.",
          "success",
        );

        setApiState((prev) =>
          prev.map((item) =>
            item._id === userId
              ? {
                  ...item,
                  manualCheckIn: false,
                  attendance: {
                    ...item.attendance,
                    check_out: new Date(),
                  },
                  currentVehicle: null,
                }
              : item,
          ),
        );
      }
    } catch (error) {
      Swal.fire(
        "Error!",
        error.response?.data?.message || "Failed to perform Manual Check-Out.",
        "error",
      );
    }
  };

  const handleSubmitManualCheckIn = async ({
    user,
    numberplate,
    client_id,
    attendanceDate,
    dutyType,
  }) => {
    try {
      if (!user?._id) {
        Swal.fire("Error!", "User data is not valid.", "error");
        return;
      }

      // const isDriver = Boolean(
      //   user?.currentVehicle ||
      //   user?.vehicle ||
      //   user?.id_driver ||
      //   user?.driver,
      // );

      // if (isDriver && !numberplate) {
      //   Swal.fire("Error!", "Please select a vehicle.", "error");
      //   return;
      // }

      // if (isDriver && !client_id) {
      //   Swal.fire("Error!", "Please select a client.", "error");
      //   return;
      // }

      // if (!attendanceDate) {
      //   Swal.fire("Error!", "Please select an attendance date.", "error");
      //   return;
      // }

      // const today = moment().format("YYYY-MM-DD");

      // if (moment(attendanceDate, "YYYY-MM-DD", true).isAfter(today)) {
      //   Swal.fire(
      //     "Invalid Date",
      //     "Attendance cannot be marked for a future date.",
      //     "warning",
      //   );
      //   return;
      // }

      // const isHistoricalDate = attendanceDate < today;
      const isExistingDriver = Boolean(
        user?.currentVehicle ||
        user?.vehicle ||
        user?.id_driver ||
        user?.driver,
      );

      // Explicitly selected duty type takes precedence over the user's usual role.
      const requiresVehicle =
        dutyType === "Service" ||
        dutyType === "Driver" ||
        (!dutyType && isExistingDriver);

      const requiresClient =
        dutyType === "Service" ||
        dutyType === "Free" ||
        dutyType === "Driver" ||
        (!dutyType && isExistingDriver);

      if (requiresVehicle && !numberplate) {
        Swal.fire("Error!", "Please select a vehicle.", "error");
        return;
      }

      if (requiresClient && !client_id) {
        Swal.fire("Error!", "Please select a client.", "error");
        return;
      }

      if (dutyType !== "Charging" && !attendanceDate) {
        Swal.fire("Error!", "Please select an attendance date.", "error");
        return;
      }

      const today = moment().format("YYYY-MM-DD");

      if (
        attendanceDate &&
        moment(attendanceDate, "YYYY-MM-DD", true).isAfter(today)
      ) {
        Swal.fire(
          "Invalid Date",
          "Attendance cannot be marked for a future date.",
          "warning",
        );
        return;
      }

      const isHistoricalDate = attendanceDate ? attendanceDate < today : false;

      // const data = {
      //   id_user: user._id,
      //   numberplate,
      //   client_id,
      //   attendanceDate,
      // };
      const data = {
        id_user: user._id,
        ...(numberplate && { numberplate }),
        ...(client_id && { client_id }),
        ...(attendanceDate && { attendanceDate }),
        ...(dutyType && { dutyType }),
      };

      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/v1/user/manual-checkin`,
        data,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );

      if (
        response.status === 200 ||
        response.status === 201 ||
        response.data?.success
      ) {
        Swal.fire(
          "Success!",
          isHistoricalDate
            ? `Historical attendance marked successfully for ${moment(
                attendanceDate,
              ).format("DD MMM YYYY")}.`
            : "Manual Check-In completed successfully.",
          "success",
        );

        // Only today's check-in should update live attendance UI.
        if (!isHistoricalDate) {
          setApiState((prevState) =>
            prevState.map((item) =>
              item._id === user._id ? { ...item, manualCheckIn: true } : item,
            ),
          );
        }

        setShowModal(false);
        setSelectedVehicle("");
        setSelectedClient("");
        setManualAttendanceDate(today);
      } else {
        Swal.fire(
          "Error!",
          response.data?.message || "Failed to perform Manual Check-In.",
          "error",
        );
      }
    } catch (error) {
      console.error("Manual Check-In Error:", error);

      Swal.fire(
        "Error!",
        error.response?.data?.message || "Failed to perform Manual Check-In.",
        "error",
      );
    }
  };

  useEffect(() => {
    setStateUpdated((prev) => !prev);
  }, [apistate]);

  const calculateClientCounts = (users) => {
    const counts = users.reduce((acc, user) => {
      const clients = user.id_client;
      if (Array.isArray(clients)) {
        clients.forEach((client) => {
          acc[client.name] = (acc[client.name] || 0) + 1;
        });
      }
      return acc;
    }, {});
    setClientCounts(counts);
  };
  useEffect(() => {
    calculateClientCounts(apistate);
  }, [apistate]);

  // useEffect(() => {
  //   fetchUsers(currentPage);
  // }, [currentPage]);

  useEffect(() => {
    fetchUsers(currentPage, rowsPerPage);
  }, [
    currentPage,
    rowsPerPage,
    dataFilter,
    statusFilter,
    clientFilter,
    staffTypeFilter,
    monthFilter,
    rentalFilter,
    userSourceFilter,
    thirdPartyProviderFilter,
  ]);

  useEffect(() => {
    setCurrentPage(1);
  }, [
    dataFilter,
    statusFilter,
    clientFilter,
    staffTypeFilter,
    monthFilter,
    rentalFilter,
    userSourceFilter,
    thirdPartyProviderFilter,
  ]);

  const handleUserHistoryClick = (row) => {
    navigate(`/userhistory/${row._id}`);
  };

  const fetchUsers = async (page = 1, limit = rowsPerPage) => {
    try {
      const token = localStorage.getItem("token");
      const userRole = localStorage.getItem("userRole");

      if (!token) return;

      let apiUrl;

      if (userRole === "superadmin") {
        apiUrl = `/api/v1/admin/users`;
      } else if (userRole === "admin") {
        apiUrl = `/api/v1/hub/admin/users`;
      } else if (userRole === "clientmanager") {
        apiUrl = `/api/v1/hub/client/users`;
      } else return;

      // 🔥 PAGINATED QUERY
      let query = `?page=${page}&limit=${limit}`;

      if (dataFilter) query += `&search=${dataFilter}`;
      if (statusFilter) query += `&status=${statusFilter}`;
      // if (clientFilter) query += `&client=${clientFilter}`;
      if (clientFilter?.length) query += `&client=${clientFilter.join(",")}`;
      // if (staffTypeFilter) query += `&staffType=${staffTypeFilter}`;
      if (staffTypeFilter) query += `&staffType=${staffTypeFilter}`;
      if (monthFilter) {
        const month = String(monthFilter.getMonth() + 1).padStart(2, "0");
        const year = monthFilter.getFullYear();
        query += `&onboardMonth=${month}/${year}`;
      }
      if (rentalFilter !== "") {
        query += `&rental=${rentalFilter}`;
      }
      if (userSourceFilter) {
        query += `&userSource=${encodeURIComponent(userSourceFilter)}`;
      }

      if (thirdPartyProviderFilter.trim()) {
        query += `&thirdPartyProvider=${encodeURIComponent(
          thirdPartyProviderFilter.trim(),
        )}`;
      }
      // 🔥 NON PAGINATED QUERY
      let fullQuery = `?`;

      if (dataFilter) fullQuery += `search=${dataFilter}&`;
      if (statusFilter) fullQuery += `status=${statusFilter}&`;
      if (clientFilter?.length)
        fullQuery += `client=${clientFilter.join(",")}&`;
      if (staffTypeFilter) fullQuery += `staffType=${staffTypeFilter}&`;
      if (monthFilter) {
        const month = String(monthFilter.getMonth() + 1).padStart(2, "0");
        const year = monthFilter.getFullYear();
        fullQuery += `onboardMonth=${month}/${year}&`;
      }
      if (rentalFilter !== "") {
        fullQuery += `rental=${rentalFilter}&`;
      }
      // User Source Filter
      if (userSourceFilter) {
        fullQuery += `userSource=${encodeURIComponent(userSourceFilter)}&`;
      }

      // Third-Party Provider Filter
      if (thirdPartyProviderFilter.trim()) {
        fullQuery += `thirdPartyProvider=${encodeURIComponent(
          thirdPartyProviderFilter.trim(),
        )}&`;
      }
      // 🔥 CALL BOTH
      const [paginatedRes, fullRes] = await Promise.all([
        axios.get(`${process.env.REACT_APP_BASE_URL}${apiUrl}${query}`, {
          headers: { Authorization: `Bearer ${token}` },
        }),
        axios.get(`${process.env.REACT_APP_BASE_URL}${apiUrl}${fullQuery}`, {
          headers: { Authorization: `Bearer ${token}` },
        }),
      ]);

      const users = paginatedRes.data.users || [];
      const allUsers = fullRes.data.users || [];

      let filteredUsers = [...allUsers];

      const today = new Date();
      const start = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate(),
      );

      const end = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate() + 1,
      );

      // filteredUsers = filteredUsers.filter((user) => user.status === "Active");

      if (
        attendanceFilter === "present" ||
        attendanceFilter === "leave" ||
        attendanceFilter === "absent"
      ) {
        filteredUsers = filteredUsers.filter(
          (user) => user.status === "Active",
        );
      }

      if (attendanceFilter === "present") {
        filteredUsers = filteredUsers.filter((user) => {
          const checkIn = user?.attendance?.check_in;
          return (
            checkIn && new Date(checkIn) >= start && new Date(checkIn) < end
          );
        });
      }

      if (attendanceFilter === "leave") {
        filteredUsers = filteredUsers.filter((user) => {
          const checkIn = user?.attendance?.check_in;

          const isCheckedIn =
            checkIn && new Date(checkIn) >= start && new Date(checkIn) < end;

          return todayLeaveMap[user._id] === true && !isCheckedIn;
        });
      }

      if (attendanceFilter === "absent") {
        filteredUsers = filteredUsers.filter((user) => {
          const checkIn = user?.attendance?.check_in;

          const isCheckedIn =
            checkIn && new Date(checkIn) >= start && new Date(checkIn) < end;

          const isOnLeave = todayLeaveMap[user._id] === true;

          return !isCheckedIn && !isOnLeave;
        });
      }

      if (attendanceFilter === "total") {
        filteredUsers = filteredUsers.filter(
          (user) => user.status === "Active",
        );
      }

      // SORT
      const statusPriority = { active: 1, inactive: 2 };

      const sortFn = (data) =>
        [...data].sort((a, b) => {
          const A = statusPriority[a.status?.toLowerCase()] || 999;
          const B = statusPriority[b.status?.toLowerCase()] || 999;
          return A - B;
        });

      const startIndex = (page - 1) * limit;
      const paginatedUsers = filteredUsers.slice(
        startIndex,
        startIndex + limit,
      );

      setApiState(sortFn(paginatedUsers));
      setFullUsers(sortFn(filteredUsers));
      setTotalRows(filteredUsers.length);
    } catch (err) {
      console.error("Fetch users error", err);
    }
  };

  useEffect(() => {
    if (!fullUsers.length) return;

    let present = 0;
    let absent = 0;
    let leave = 0;

    const today = new Date();
    const start = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate(),
    );
    const end = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate() + 1,
    );

    fullUsers.forEach((user) => {
      if (user.status !== "Active") return;

      const checkIn = user?.attendance?.check_in;
      const isCheckedIn =
        checkIn && new Date(checkIn) >= start && new Date(checkIn) < end;

      const isOnLeave = todayLeaveMap[user._id] === true;

      if (isCheckedIn) present++;
      else if (isOnLeave) leave++;
      else absent++;
    });

    setPresentCount(present);
    setAbsentCount(absent);
    setLeaveCount(leave);
    setTotalUsers(present + absent + leave);

    calculateTotalBasicSalary(fullUsers); // 🔥 FIX SALARY
  }, [fullUsers, todayLeaveMap]);

  const handleFilterClick = (filterType) => {
    setAttendanceFilter(filterType);
    if (!fullUsers.length) return;

    const today = new Date();
    const start = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate(),
    );
    const end = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate() + 1,
    );

    let filtered = fullUsers.filter((user) => user.status === "Active");

    if (filterType === "present") {
      filtered = filtered.filter((user) => {
        const checkIn = user?.attendance?.check_in;
        return checkIn && new Date(checkIn) >= start && new Date(checkIn) < end;
      });
    } else if (filterType === "leave") {
      filtered = filtered.filter((user) => {
        const checkIn = user?.attendance?.check_in;
        const isCheckedIn =
          checkIn && new Date(checkIn) >= start && new Date(checkIn) < end;

        return todayLeaveMap[user._id] === true && !isCheckedIn;
      });
    } else if (filterType === "absent") {
      filtered = filtered.filter((user) => {
        const checkIn = user?.attendance?.check_in;
        const isCheckedIn =
          checkIn && new Date(checkIn) >= start && new Date(checkIn) < end;

        const isOnLeave = todayLeaveMap[user._id] === true;

        return !isCheckedIn && !isOnLeave;
      });
    }

    // TOTAL → no extra filter
    else if (filterType === "total") {
      filtered = fullUsers.filter((user) => user.status === "Active");
    }

    // ✅ UPDATE SALARY
    calculateTotalBasicSalary(filtered);

    // ✅ APPLY PAGINATION MANUALLY
    const startIndex = (currentPage - 1) * rowsPerPage;
    const paginated = filtered.slice(startIndex, startIndex + rowsPerPage);

    setApiState(paginated); // table data
    setTotalRows(filtered.length); // pagination count
  };

  useEffect(() => {
    if (Object.keys(todayLeaveMap).length > 0) {
      fetchUsers();
    }
  }, [todayLeaveMap]);

  const handleToggleTracking = async (row) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        console.error("No token found");
        return;
      }

      const updatedTracking = !row.tracking;

      // Create FormData and append the updated Tracking value
      const formData = new FormData();
      formData.append("tracking", updatedTracking);

      const response = await axios.put(
        `${process.env.REACT_APP_BASE_URL}/api/v1/user/${row._id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response.status === 200) {
        const updatedUsers = apistate.map((user) =>
          user._id === row._id ? { ...user, tracking: updatedTracking } : user,
        );
        setApiState(updatedUsers);
        Swal.fire("Updated!", "Tracking status has been updated.", "success");
      } else {
        Swal.fire(
          "Error!",
          "There was an error updating Tracking status.",
          "error",
        );
      }
    } catch (error) {
      console.error("Error updating Tracking status:", error);
      Swal.fire(
        "Error!",
        "There was an error updating Tracking status.",
        "error",
      );
    }
  };

  const handleToggleMultipleCheckIn = async (row) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        console.error("No token found");
        return;
      }

      const updatedCheckIn = !row.multipleCheckIn;

      // Create FormData and append the updated multipleCheckIn value
      const formData = new FormData();
      formData.append("multipleCheckIn", updatedCheckIn); // Ensure this key matches backend expectation

      const response = await axios.put(
        `${process.env.REACT_APP_BASE_URL}/api/v1/user/${row._id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response.status === 200) {
        setApiState((prevState) =>
          prevState.map((item) =>
            item._id === row._id
              ? { ...item, multipleCheckIn: updatedCheckIn }
              : item,
          ),
        );
        Swal.fire("Updated!", "Checkin status has been updated.", "success");
      } else {
        Swal.fire(
          "Error!",
          "There was an error updating Checkin status.",
          "error",
        );
      }
    } catch (error) {
      console.error("Error updating Checkin status:", error);
      Swal.fire(
        "Error!",
        "There was an error updating Checkin status.",
        "error",
      );
    }
  };

  const handleToggleGeoFencing = async (row) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        console.error("No token found");
        return;
      }

      const updatedGeoFencing = !row.geoFencing;

      // Create FormData and append the updated geoFencing value
      const formData = new FormData();
      formData.append("geoFencing", updatedGeoFencing);

      const response = await axios.put(
        `${process.env.REACT_APP_BASE_URL}/api/v1/user/${row._id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response.status === 200) {
        const updatedUsers = apistate.map((user) =>
          user._id === row._id
            ? { ...user, geoFencing: updatedGeoFencing }
            : user,
        );
        setApiState(updatedUsers);
        Swal.fire("Updated!", "GeoFencing status has been updated.", "success");
      } else {
        Swal.fire(
          "Error!",
          "There was an error updating GeoFencing status.",
          "error",
        );
      }
    } catch (error) {
      console.error("Error updating GeoFencing status:", error);
      Swal.fire(
        "Error!",
        "There was an error updating GeoFencing status.",
        "error",
      );
    }
  };

  const handleToggleRental = async (row) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        console.error("No token found");
        return;
      }

      const updatedRental = !row.rental;

      // Create FormData and append the updated rental value
      const formData = new FormData();
      formData.append("rental", updatedRental);

      const response = await axios.put(
        `${process.env.REACT_APP_BASE_URL}/api/v1/user/${row._id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response.status === 200) {
        const updatedUsers = apistate.map((user) =>
          user._id === row._id ? { ...user, rental: updatedRental } : user,
        );
        setApiState(updatedUsers);
        Swal.fire("Updated!", "Rental status has been updated.", "success");
      } else {
        Swal.fire(
          "Error!",
          "There was an error updating Rental status.",
          "error",
        );
      }
    } catch (error) {
      console.error("Error updating Rental status:", error);
      Swal.fire(
        "Error!",
        "There was an error updating Rental status.",
        "error",
      );
    }
  };

  const setUpdateStoreBtn = (row) => {
    setOpen_update_modal({
      render: !open_update_modal.render,
      modal_open: true,
    });
    setUpdate_modal_data(row);
  };

  const copyLink = () => {
    alert(46);
  };

  const updateUser = (updatedUser) => {
    setApiState((prev) =>
      prev.map((user) => (user._id === updatedUser._id ? updatedUser : user)),
    );
  };

  const viewUser = (user) => {
    setSelectedUser(user);
    setShowUserDetailModal(true);
  };

  const exportToExcel = async () => {
    try {
      const token = localStorage.getItem("token");
      const userRole = localStorage.getItem("userRole");

      let apiUrl;

      if (userRole === "superadmin") {
        apiUrl = `/api/v1/admin/users`;
      } else if (userRole === "admin") {
        apiUrl = `/api/v1/admin/users`; // adjust if different
      } else if (userRole === "clientmanager") {
        apiUrl = `/api/v1/admin/users`; // adjust if different
      } else {
        return;
      }

      // ❗ NO pagination
      let query = `?`;

      if (dataFilter) query += `search=${dataFilter}&`;
      if (statusFilter) query += `status=${statusFilter}&`;
      if (clientFilter) query += `client=${clientFilter}&`;
      if (staffTypeFilter) query += `staffType=${staffTypeFilter}&`;

      // ✅ MONTH FIX (IMPORTANT)
      if (monthFilter) {
        const month = String(monthFilter.getMonth() + 1).padStart(2, "0");
        const year = monthFilter.getFullYear();
        query += `onboardMonth=${month}/${year}&`;
      }

      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}${apiUrl}${query}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const allUsers = response.data.users || [];

      // ✅ TRANSFORM DATA
      const transformedData = allUsers.map((user) => ({
        "Employee ID":
          user.salary?.length > 0 ? user.salary[0].id_employee : "-",

        "User Name": user.name || "N/A",
        "Phone Number": user.phonenumber || "N/A",
        Email: user.email || "N/A",
        Password: user.password || "N/A",
        "Joining Date": user.joiningdate
          ? new Date(user.joiningdate).toLocaleDateString()
          : "N/A",

        "Date of Birth": user.dob
          ? new Date(user.dob).toLocaleDateString()
          : "N/A",
        "User Source": user.userSource || "InHouse",
        "Third-Party Provider": user.thirdPartyProvider || "-",
        "Account Number": user.bank_details?.account_number || "-",
        "Bank Name": user.bank_details?.bank_name || "-",
        "Branch Name": user.bank_details?.branch_name || "-",
        "IFSC Code": user.bank_details?.ifsc_code || "-",
        "Account Holder  Name": user.bank_details?.account_holder_name || "-",

        Status: user.status || "N/A",

        "Shift-In Time": user.shift_hours?.check_in || "-",
        "Shift-Out Time": user.shift_hours?.check_out || "-",

        "Check-in": user.attendance?.check_in || "-",
        "Check-out": user.attendance?.check_out || "-",

        Role: user.id_role?.role_title || "-",

        "Is Logged In": user.isLoggedIn ? "Yes" : "No",

        Longitude:
          Array.isArray(user.coordinates) && user.coordinates.length > 0
            ? user.coordinates[0].longitude
            : "-",

        Latitude:
          Array.isArray(user.coordinates) && user.coordinates.length > 0
            ? user.coordinates[0].latitude
            : "-",

        Geofencing: user.geoFencing || "-",
        Rental: user.rental || "-",

        "Staff Type": user.id_generalStaffType?.name || "-",

        "Client Name": Array.isArray(user.id_client)
          ? user.id_client.map((c) => c.name).join(", ")
          : "N/A",

        "Total Working Hrs": user.totalworkinghours || "-",
        "Working Hrs": user.workinghours || "-",

        "Multiple Check-in": user.multipleCheckIn || "-",
        "Manual Check-in": user.manualCheckIn || "-",
        "Invite Sent": user.simTrackingEnabled ? "Yes" : "No",
        "Sim Tracking": user.simTrackingTracked ? "Yes" : "No",
        Tracking: user.tracking || "-",

        "Assigned Location": Array.isArray(user.assigned_location)
          ? user.assigned_location.join(", ")
          : "N/A",

        "Current Vehicle": user.currentVehicle || "-",

        "Leave ID": user.leaveId || "-",

        Salary: Array.isArray(user.salary)
          ? user.salary.map((s) => s.basic_pay).join(", ")
          : "N/A",
      }));

      const worksheet = XLSX.utils.json_to_sheet(transformedData);
      const workbook = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(workbook, worksheet, "Users");

      XLSX.writeFile(workbook, "UsersData.xlsx");
    } catch (error) {
      console.error("Export error:", error);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return moment(dateString).format("DD-MM-YYYY");
  };

  const handleShow = (row) => {
    setOpenModal(!openModal);
    setSelectval(row);
  };
  const updateUserCounts = (filteredUsers) => {
    const today = new Date();
    const startOfDay = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate(),
    );
    const endOfDay = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate() + 1,
    );

    let present = 0;
    let absent = 0;
    let leave = 0;

    filteredUsers.forEach((user) => {
      if (user.status === "Active") {
        const checkIn = user?.attendance?.check_in;

        const isCheckedInToday =
          checkIn &&
          new Date(checkIn) >= startOfDay &&
          new Date(checkIn) < endOfDay;

        if (isCheckedInToday) present++;
        else absent++;
      }
    });

    setPresentCount(present);
    setAbsentCount(absent);
    // setTotalUsers(present + absent);
    setTotalUsers(present + absent + leave);
  };
  useEffect(() => {
    const fetchTodayLeaves = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v2/leave-requests`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          },
        );

        const today = new Date().toLocaleDateString("en-CA"); // YYYY-MM-DD
        const leaveMap = {};

        res.data?.leaveRequests?.forEach((leave) => {
          // ✅ CORRECT USER ID
          const userId = leave.id_user?._id;
          if (!userId) return;

          // ✅ Only consider Approved OR Pending (business decision)
          if (!["Approved", "Pending"].includes(leave.status)) return;

          // ✅ FIX UTC DATE ISSUE
          const startDate = new Date(leave.startDate).toLocaleDateString(
            "en-CA",
          );
          const endDate = new Date(leave.endDate).toLocaleDateString("en-CA");

          if (today >= startDate && today <= endDate) {
            leaveMap[userId] = true;
          }
        });

        console.log("✅ Today Leave Map:", leaveMap);
        setTodayLeaveMap(leaveMap);
      } catch (error) {
        console.error("❌ Leave fetch error:", error);
      }
    };

    fetchTodayLeaves();
  }, []);

  useEffect(() => {
    const fetchLeaveTypes = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v2/getAllLeaveTypes`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          },
        );

        if (res.data?.success) {
          setLeaveTypes(res.data.leaveTypes || []);
        }
      } catch (error) {
        console.error("Error fetching leave types:", error);
      }
    };

    fetchLeaveTypes();
  }, []);

  const handleApplyLeave = (row) => {
    if (todayLeaveMap[row._id]) {
      Swal.fire(
        "Leave Already Applied",
        "This user already has leave for today.",
        "info",
      );
      return;
    }
    setSelectedLeaveUser(row);
    setSelectedLeaveType("");
    setLeaveStartDate("");
    setLeaveEndDate("");
    setShowLeaveModal(true);

    if (applyLeaveButtonRef.current) {
      const rect = applyLeaveButtonRef.current.getBoundingClientRect();
      setButtonPosition({
        top: rect.top + window.scrollY,
        left: rect.left + window.scrollX,
      });
    }
  };

  const handleSubmitApplyLeave = async () => {
    try {
      if (!selectedLeaveUser?._id) {
        Swal.fire("Error!", "Invalid user selected.", "error");
        return;
      }

      if (!selectedLeaveType || !leaveStartDate || !leaveEndDate) {
        Swal.fire("Error!", "Please fill all fields.", "error");
        return;
      }

      const payload = {
        userId: selectedLeaveUser._id,
        leaveTypeId: selectedLeaveType,
        startDate: leaveStartDate,
        endDate: leaveEndDate,
      };

      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/v2/apply-leave`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );

      if (response.status === 200 || response.data?.success) {
        Swal.fire("Success!", "Leave applied successfully.", "success");

        /* =====================================================
         ✅ FIX: LOCAL DATE COMPARISON (UTC SAFE)
      ====================================================== */
        const today = new Date().toLocaleDateString("en-CA"); // YYYY-MM-DD

        const start = new Date(leaveStartDate).toLocaleDateString("en-CA");
        const end = new Date(leaveEndDate).toLocaleDateString("en-CA");

        const isTodayOnLeave = today >= start && today <= end;

        /* =====================================================
         ✅ UPDATE TOGGLE STATE IMMEDIATELY
      ====================================================== */
        if (isTodayOnLeave) {
          setTodayLeaveMap((prev) => ({
            ...prev,
            [selectedLeaveUser._id]: true,
          }));
        }

        /* =====================================================
         ✅ OPTIONAL: LOCAL TABLE STATE UPDATE
      ====================================================== */
        setApiState((prev) =>
          prev.map((item) =>
            item._id === selectedLeaveUser._id
              ? { ...item, onLeave: isTodayOnLeave }
              : item,
          ),
        );

        setShowLeaveModal(false);
      } else {
        Swal.fire(
          "Error!",
          response.data?.message || "Failed to apply leave.",
          "error",
        );
      }
    } catch (error) {
      Swal.fire(
        "Error!",
        error.response?.data?.message || "Failed to apply leave.",
        "error",
      );
    }
  };

  return (
    <>
      <Layouts />
      <Status_modal row={selectVal} openModal={openModal} />
      <Add_data_modal
        select_data={update_modal_data}
        open_update_data_modal={open_update_modal}
        onUpdateUser={updateUser}
      />
      <UserDetailModal
        show={showUserDetailModal}
        onHide={() => setShowUserDetailModal(false)}
        user={selectedUser}
      />

      <div className="container-fluid">
        <div className="row my-3">
          <div className="col-12">
            <div className="card" style={{ borderTop: "2px solid #4723d9" }}>
              {/* <div className="card-header d-flex justify-content-between border-bottom pb-1"> */}
              <div
                className="card-header d-flex align-items-center border-bottom pb-1"
                style={{
                  gap: "12px",
                  minHeight: "70px",
                  overflow: "hidden",
                }}
              >
                {/* <h4>{title}</h4> */}
                <h4
                  className="mb-0"
                  style={{
                    whiteSpace: "nowrap",
                    flexShrink: 0,
                  }}
                >
                  {title}
                </h4>
                <div
                  className="d-flex align-items-center"
                  style={{
                    gap: "10px",
                    flex: 1,
                    minWidth: 0,
                    overflow: "hidden",
                  }}
                >
                  {" "}
                  <div
                    className="d-flex align-items-center"
                    style={{
                      gap: "10px",
                      flexWrap: "nowrap",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {/* PRESENT */}
                    <button
                      onClick={() => handleFilterClick("present")}
                      style={{
                        height: "48px",
                        minWidth: "130px",
                        padding: "0 12px",
                        background: "#f0fbf3",
                        border: "1px solid #b8e5c1",
                        borderRadius: "10px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "8px",
                        cursor: "pointer",
                        flexShrink: 1,
                      }}
                    >
                      <div
                        style={{
                          width: "30px",
                          height: "30px",
                          borderRadius: "50%",
                          background: "#e9f9ed",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <FontAwesomeIcon
                          icon={faUserCheck}
                          style={{
                            color: "#18a94b",
                            fontSize: "14px",
                          }}
                        />
                      </div>

                      <span
                        style={{
                          fontSize: "14px",
                          color: "#16863d",
                        }}
                      >
                        Present
                      </span>

                      <span
                        style={{
                          height: "22px",
                          width: "1px",
                          background: "#cfe8d4",
                        }}
                      />

                      <strong
                        style={{
                          fontSize: "16px",
                          color: "#16863d",
                        }}
                      >
                        {presentCount}
                      </strong>
                    </button>

                    {/* ABSENT */}
                    <button
                      onClick={() => handleFilterClick("absent")}
                      style={{
                        height: "48px",
                        minWidth: "125px",
                        padding: "0 12px",
                        background: "#fff5f5",
                        border: "1px solid #f0b8b8",
                        borderRadius: "10px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "8px",
                        cursor: "pointer",
                        flexShrink: 1,
                      }}
                    >
                      <div
                        style={{
                          width: "30px",
                          height: "30px",
                          borderRadius: "50%",
                          background: "#fdeaea",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <FontAwesomeIcon
                          icon={faUserXmark}
                          style={{
                            color: "#dc3545",
                            fontSize: "14px",
                          }}
                        />
                      </div>

                      <span
                        style={{
                          fontSize: "14px",
                          color: "#c82333",
                        }}
                      >
                        Absent
                      </span>

                      <span
                        style={{
                          height: "22px",
                          width: "1px",
                          background: "#edcaca",
                        }}
                      />

                      <strong
                        style={{
                          fontSize: "16px",
                          color: "#c82333",
                        }}
                      >
                        {absentCount}
                      </strong>
                    </button>

                    {/* TOTAL */}
                    <button
                      onClick={() => handleFilterClick("total")}
                      style={{
                        height: "48px",
                        minWidth: "120px",
                        padding: "0 12px",
                        background: "#f8f9fa",
                        border: "1px solid #dfe3e8",
                        borderRadius: "10px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "8px",
                        cursor: "pointer",
                        flexShrink: 1,
                      }}
                    >
                      <div
                        style={{
                          width: "30px",
                          height: "30px",
                          borderRadius: "50%",
                          background: "#f1f3f5",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <FontAwesomeIcon
                          icon={faUsers}
                          style={{
                            color: "#555",
                            fontSize: "14px",
                          }}
                        />
                      </div>

                      <span
                        style={{
                          fontSize: "14px",
                          color: "#333",
                        }}
                      >
                        Total
                      </span>

                      <span
                        style={{
                          height: "22px",
                          width: "1px",
                          background: "#ddd",
                        }}
                      />

                      <strong
                        style={{
                          fontSize: "16px",
                          color: "#111",
                        }}
                      >
                        {totalUsers}
                      </strong>
                    </button>

                    {/* LEAVE */}
                    <button
                      onClick={() => handleFilterClick("leave")}
                      style={{
                        height: "48px",
                        minWidth: "120px",
                        padding: "0 12px",
                        background: "#fff8e9",
                        border: "1px solid #f2d49b",
                        borderRadius: "10px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "8px",
                        cursor: "pointer",
                        flexShrink: 1,
                      }}
                    >
                      <div
                        style={{
                          width: "30px",
                          height: "30px",
                          borderRadius: "50%",
                          background: "#fff5df",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <FontAwesomeIcon
                          icon={faCalendarDays}
                          style={{
                            color: "#d88900",
                            fontSize: "14px",
                          }}
                        />
                      </div>

                      <span
                        style={{
                          fontSize: "14px",
                          color: "#c47700",
                        }}
                      >
                        Leave
                      </span>

                      <span
                        style={{
                          height: "22px",
                          width: "1px",
                          background: "#efdcb7",
                        }}
                      />

                      <strong
                        style={{
                          fontSize: "16px",
                          color: "#c47700",
                        }}
                      >
                        {leaveCount}
                      </strong>
                    </button>

                    {/* TOTAL SALARY */}
                    <button
                      disabled
                      style={{
                        height: "48px",
                        minWidth: "165px",
                        padding: "0 12px",
                        background: "#f4f8ff",
                        border: "1px solid #b8cff0",
                        borderRadius: "10px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "8px",
                        cursor: "default",
                        flexShrink: 1,
                      }}
                    >
                      <div
                        style={{
                          width: "30px",
                          height: "30px",
                          borderRadius: "50%",
                          background: "#e8f0ff",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <FontAwesomeIcon
                          icon={faMoneyBillWave}
                          style={{
                            color: "#2463c5",
                            fontSize: "14px",
                          }}
                        />
                      </div>

                      <span
                        style={{
                          fontSize: "14px",
                          color: "#2463c5",
                        }}
                      >
                        Total Salary
                      </span>

                      <span
                        style={{
                          height: "22px",
                          width: "1px",
                          background: "#cfddf5",
                        }}
                      />

                      <strong
                        style={{
                          fontSize: "15px",
                          color: "#2463c5",
                        }}
                      >
                        ₹ {totalBasicSalary}
                      </strong>
                    </button>
                  </div>
                </div>
                <div>
                  {/* <Link to="/create-user">
                    <div className="btn btn-info btn-sm text-white">
                      Add User
                    </div>
                  </Link> */}

                  {userRole === "superadmin" && (
                    <Link to="/create-user">
                      <div className="btn btn-info btn-sm text-white me-2">
                        Add Users
                      </div>
                    </Link>
                  )}
                  {/* <button
                    onClick={exportToExcel}
                    className="btn btn-success btn-sm ms-2"
                  >
                    Export to Excel
                  </button> */}
                  {userRole === "superadmin" && (
                    <button
                      onClick={exportToExcel}
                      className="btn btn-success btn-sm me-2"
                    >
                      Export to Excel
                    </button>
                  )}
                </div>
              </div>
              <div className="card-body">
                <DataTable_Component
                  apidata={apistate}
                  columns={columns}
                  totalRows={totalRows}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  rowsPerPage={rowsPerPage}
                  setRowsPerPage={setRowsPerPage}
                  dataFilter={dataFilter}
                  setDataFilter={setDataFilter}
                  statusFilter={statusFilter}
                  setStatusFilter={setStatusFilter}
                  clientFilter={clientFilter}
                  setClientFilter={setClientFilter}
                  staffTypeFilter={staffTypeFilter}
                  setStaffTypeFilter={setStaffTypeFilter}
                  monthFilter={monthFilter}
                  setMonthFilter={setMonthFilter}
                  rentalFilter={rentalFilter}
                  setRentalFilter={setRentalFilter}
                  userSourceFilter={userSourceFilter}
                  setUserSourceFilter={setUserSourceFilter}
                  thirdPartyProviderFilter={thirdPartyProviderFilter}
                  setThirdPartyProviderFilter={setThirdPartyProviderFilter}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {showModal && (
        <>
          {/* Backdrop with blur effect */}
          <div
            className="modal-backdrop"
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              backdropFilter: "blur(5px)", // Apply blur effect to the background
              zIndex: 999, // Ensure it's behind the modal
            }}
          ></div>

          {/* Modal Content */}
          <div
            className="modal-overlay"
            style={{
              position: "fixed", // Fixed position to center the modal on the screen
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)", // Center the modal
              zIndex: 1000, // Ensure modal is above the backdrop
            }}
          >
            <div
              className="modal-content"
              style={{
                backgroundColor: "#fff",
                borderRadius: "8px",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                minWidth: "300px",
                maxWidth: "500px", // Modal width
                // width: "320px", // Define a fixed width for the modal
                // padding: "15px", // Add padding for content inside
              }}
            >
              <div
                className="d-flex justify-content-between align-items-center mb-3"
                style={{
                  marginTop: "20px",
                  paddingLeft: "15px",
                  color: "orange",
                }}
              >
                <h2>
                  {" "}
                  <b>
                    {" "}
                    <u>Manual Check-In</u> :-
                  </b>
                </h2>
              </div>
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  handleSubmitManualCheckIn({
                    user: selectedUser,
                    numberplate: selectedVehicle,
                    client_id: selectedClient,
                    attendanceDate: manualAttendanceDate,
                    dutyType: selectedDutyType,
                  });
                }}
              >
                <div className="col-md-6 mt-3" style={{ paddingLeft: "20px" }}>
                  <label htmlFor="dutyType" className="form-label">
                    Duty Type
                  </label>

                  <select
                    id="dutyType"
                    className="form-control"
                    style={{ width: "260px" }}
                    value={selectedDutyType}
                    onChange={(e) => {
                      setSelectedDutyType(e.target.value);
                      setSelectedVehicle("");
                      setSelectedClient("");
                    }}
                  >
                    <option value="">Use Existing Behavior</option>

                    {(selectedUser?.dutyTypes || []).map((dutyType) => (
                      <option key={dutyType} value={dutyType}>
                        {dutyType}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-md-6 mt-3" style={{ paddingLeft: "20px" }}>
                  <label htmlFor="manualAttendanceDate" className="form-label">
                    Attendance Date
                  </label>

                  <input
                    id="manualAttendanceDate"
                    type="date"
                    className="form-control"
                    value={manualAttendanceDate}
                    max={moment().format("YYYY-MM-DD")}
                    onChange={(e) => setManualAttendanceDate(e.target.value)}
                    // required
                    required={selectedDutyType !== "Charging"}
                    style={{ width: "260px" }}
                  />

                  {manualAttendanceDate &&
                    manualAttendanceDate < moment().format("YYYY-MM-DD") && (
                      <small className="text-warning d-block mt-1">
                        Historical attendance will be marked as checked out
                        automatically.
                      </small>
                    )}
                </div>

                <div className="col-md-6 mt-3" style={{ paddingLeft: "20px" }}>
                  <label htmlFor="vehicle">NUMBER PLATE</label>
                  <Select
                    options={vehicles.map((vehicle) => ({
                      value: vehicle.numberplate,
                      label: vehicle.numberplate,
                    }))}
                    value={
                      selectedVehicle
                        ? { value: selectedVehicle, label: selectedVehicle }
                        : null
                    }
                    onChange={(selectedOption) =>
                      setSelectedVehicle(selectedOption?.value)
                    }
                    placeholder="Select Vehicle"
                    isClearable
                    styles={{
                      container: (provided) => ({
                        ...provided,
                        width: 260,
                      }),
                    }}
                  />
                </div>

                <div className="col-md-6 mt-3" style={{ paddingLeft: "20px" }}>
                  <label htmlFor="client_id">Select Client</label>
                  <select
                    id="client_id"
                    value={selectedClient}
                    onChange={(e) => setSelectedClient(e.target.value)}
                    className="form-control"
                    style={{ width: "260px" }}
                  >
                    <option value="">Select Clients</option>
                    {clients
                      .filter((client) => client.status === "Active")
                      .map((client) => (
                        <option key={client._id} value={client._id}>
                          {client.name}
                        </option>
                      ))}
                  </select>
                </div>

                <div
                  className="form-group mt-3 d-flex"
                  style={{ paddingLeft: "20px" }}
                >
                  <button
                    type="submit"
                    className="btn btn-primary"
                    style={{ marginTop: "20px" }}
                  >
                    Submit
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary ms-2"
                    style={{ marginTop: "20px" }}
                    onClick={() => setShowModal(false)}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        </>
      )}

      {showLeaveModal && (
        <>
          {/* Backdrop */}
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0,0,0,0.5)",
              backdropFilter: "blur(5px)",
              zIndex: 999,
            }}
          />

          {/* Modal */}
          <div
            style={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: 1000,
            }}
          >
            <div
              style={{
                background: "#fff",
                borderRadius: "8px",
                minWidth: "350px",
                padding: "20px",
              }}
            >
              <h3 style={{ color: "orange" }}>
                <b>
                  <u>Apply Leave</u>
                </b>
              </h3>

              {/* Leave Type */}
              <div className="mt-3">
                <label>Leave Type</label>
                <select
                  className="form-control"
                  value={selectedLeaveType}
                  onChange={(e) => setSelectedLeaveType(e.target.value)}
                >
                  <option value="">Select Leave Type</option>
                  {leaveTypes.map((type) => (
                    <option key={type._id} value={type._id}>
                      {type.name}
                    </option>
                  ))}
                </select>
              </div>

              {/* Start Date */}
              <div className="mt-3">
                <label>Start Date</label>
                <input
                  type="date"
                  className="form-control"
                  value={leaveStartDate}
                  onChange={(e) => setLeaveStartDate(e.target.value)}
                />
              </div>

              {/* End Date */}
              <div className="mt-3">
                <label>End Date</label>
                <input
                  type="date"
                  className="form-control"
                  value={leaveEndDate}
                  onChange={(e) => setLeaveEndDate(e.target.value)}
                />
              </div>

              {/* Buttons */}
              <div className="d-flex mt-4">
                <button
                  className="btn btn-primary"
                  onClick={handleSubmitApplyLeave}
                >
                  Submit
                </button>
                <button
                  className="btn btn-secondary ms-2"
                  onClick={() => setShowLeaveModal(false)}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}
